import { useLocation, useNavigate } from "react-router-dom";
import MainTable from "../../components/tables/MainTable";
import endpoints from "../../services/endpoints";
import { TableDetailsItem } from "../../components/tables/tableFunctions";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../store";
import useTranslation from "../../components/CustomHooks/useTranslation";
import { adminContents } from "../AdminManagement/components/AdminManagementContent";
import { ReactNode, useCallback, useEffect, useState } from "react";
import { setPreviousUrl } from "../../store/slices/geolocationSlice";

type Props = {
  children?: ReactNode;
};
export default function ListingPayAdvanced({ children }: Props) {
  const navigation = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { raiseETopUpRequest } = endpoints;
  const location = useLocation();
  const { translate } = useTranslation(adminContents);

  const [searchPlaceholder, setSearchPlaceholder] =
    useState<string>("transaction id");
  const [isTransitioning, setIsTransitioning] = useState<boolean>(false);

  const TableDetails: { [key: string]: TableDetailsItem } = {
    "Transaction ID": {
      id: "transaction_id",
      className: "min-w-[200px]",
    },
    "Transaction Date": {
      id: "transaction_date",
      className: "min-w-[197px]",
      custom: ["transaction_date"],
      sort: true,
    },
    "Requested User Code": {
      id: "requested_user_code",
      className: "min-w-[150px]",
    },
    "Requested Name": {
      id: "requested_name",
      sort: true,
      // className: "min-w-[196px]",
    },
    "Advance Amount": {
      id: "advance_amount",
      custom: ["advance_amount"],
    },
    "Payable Amount": {
      id: "payable_amount",
      custom: ["payable_amount"],
    },
    "Status": {
      id: "custom_status",
      // className: "min-w-[200px]",
      custom: ["custom_status"],
    },
    Actions: {
      id: "actions",
      className: "min-w-[200px]", // Adding className here
      actionTypes: ["payment"]
    },
  };
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleActions = async (id: string, key: string, text?: string) => {
    dispatch(setPreviousUrl(location.pathname + location.search));
    navigation(`/e-top-up-request/e-top-up/raise-e-top-up-request/pay/${id}`);
  };
  const staticText = {
    emptyScreenText: {
      heading1: translate("There are no advance payment added yet"),
    },
  };
  const SEARCH_PLACEHOLDERS = [
    "transaction id",
    "requested user code",
    "requested name",
  ] as const;

  const rotatePlaceholder = useCallback(() => {
    setIsTransitioning(true);

    setTimeout(() => {
      setSearchPlaceholder((prev) => {
        const currentIndex = SEARCH_PLACEHOLDERS.indexOf(
          prev as (typeof SEARCH_PLACEHOLDERS)[number]
        );
        const nextIndex = (currentIndex + 1) % SEARCH_PLACEHOLDERS.length; // Loop cyclically
        return SEARCH_PLACEHOLDERS[nextIndex];
      });
      setIsTransitioning(false);
    }, 500);
  }, []);

  useEffect(() => {
    const interval = setInterval(rotatePlaceholder, 2500);
    return () => clearInterval(interval);
  }, [rotatePlaceholder]);
  return (
    <div>
      <MainTable
        staticText={staticText}
        mainEndPoint={`${raiseETopUpRequest}`}
        staticEndPoint={'status=Approved,Rejected'}
        TableDetails={TableDetails}
        handleActions={handleActions}
        params={{ page_number: "1" }}
        searchPlaceholder={`Search by ${searchPlaceholder}`}
        placeholderClassName={`search-placeholder ${
          isTransitioning ? "transitioning" : ""
        }`}
        customHeight={true}
        filters={true}
        statusNotFilter={true}
        exporting={true}
        stickyStyleTableHeader={'top-[0.5px]'}
        TabChildren={
          <div className="pt-6 pl-6">
            {children}
            <p className="pt-6 text-primary_text text-subTitle">
              List of all Advanced Payment
            </p>
          </div>
        }
      />
    </div>
  );
}
